<template>
  <div class="participation-admin">
    <a-alert type="info" show-icon :message="t('scope')" />
    <a-alert v-if="!enabled" type="warning" show-icon :message="t('claimsOff')" class="spaced" />
    <template v-if="showAssignments">
    <div class="section-heading"><h4>{{ t('representative') }}</h4><a-button v-if="allowNewAssignments" type="primary" :disabled="!enabled || !entries.length" @click="openRepresentative()">{{ t('representative') }}</a-button></div>
    <p class="muted">{{ t('representativeHelp') }}</p>
    <a-table :data-source="representatives" :columns="representativeColumns" row-key="id" :loading="loading" :pagination="{ pageSize: 5 }" :scroll="{ x: 600 }">
      <template slot="active" slot-scope="value"><a-tag :color="value === 1 ? 'green' : 'default'">{{ t(value === 1 ? 'active' : 'inactive') }}</a-tag></template>
      <template slot="action" slot-scope="value, row"><a-button v-if="row.active === 1" type="link" @click="openRepresentative(row)">{{ t('revokeAccess') }}</a-button></template>
    </a-table>
    </template>
    <div class="section-heading"><h4>{{ t('review') }}</h4><div class="toolbar"><a-select v-model="entryId" allow-clear :placeholder="t('all')" style="width:300px;max-width:100%" @change="loadClaims"><a-select-option v-for="entry in entries" :key="entry.id" :value="entry.id">{{ entryLabel(entry) }}</a-select-option></a-select><a-button @click="loadAll">{{ t('refresh') }}</a-button><a-button @click="loadHistory">{{ t('history') }}</a-button></div></div>
    <a-table :data-source="claims" :columns="claimColumns" row-key="id" :loading="loading" :pagination="{ pageSize: 10 }" :scroll="{ x: 800 }">
      <template slot="role" slot-scope="value">{{ t(value || 'OTHER') }}</template>
      <template slot="status" slot-scope="value"><a-tag :color="value === 'CONFIRMED' ? 'green' : value === 'PENDING' ? 'gold' : 'default'">{{ t(value) }}</a-tag></template>
      <template slot="action" slot-scope="value, row">
        <template v-if="row.status === 'PENDING' && enabled"><a-button type="link" @click="openReview(row, 'CONFIRMED')">{{ t('confirm') }}</a-button><a-button type="link" @click="openReview(row, 'REJECTED')">{{ t('reject') }}</a-button></template>
        <a-button v-if="row.status === 'CONFIRMED'" type="link" @click="openReview(row, 'REVOKED')">{{ t('revoke') }}</a-button>
      </template>
    </a-table>
    <a-modal v-model="representativeVisible" :title="t(representativeForm.active === 0 ? 'revokeAccess' : 'representative')" :confirm-loading="busy" :mask-closable="false" @ok="saveRepresentative">
      <a-form layout="vertical">
        <a-form-item :label="t('teamName')" required><a-select v-model="representativeForm.entryId" :disabled="representativeForm.active === 0"><a-select-option v-for="entry in entries" :key="entry.id" :value="entry.id">{{ entryLabel(entry) }}</a-select-option></a-select></a-form-item>
        <a-form-item :label="t('jiangkNo')" required><a-input v-model="representativeForm.jiangkNo" :disabled="representativeForm.active === 0" :max-length="40" /></a-form-item>
        <a-form-item :label="t('evidence')" required><a-textarea v-model="representativeForm.verificationNote" :rows="3" :max-length="500" /></a-form-item>
      </a-form>
      <p class="muted">{{ t('representativeHelp') }}</p>
    </a-modal>
    <a-modal v-model="reviewVisible" :title="t('review')" :confirm-loading="busy" :mask-closable="false" @ok="saveReview">
      <p><strong>{{ reviewForm.displayName }}</strong> · {{ entryLabel(reviewForm) }}</p>
      <a-tag>{{ t(reviewForm.status) }}</a-tag>
      <a-form layout="vertical"><a-form-item :label="t('evidence')" required><a-textarea v-model="reviewForm.reason" :rows="3" :max-length="500" /></a-form-item></a-form>
      <p class="muted">{{ t('scope') }}</p>
    </a-modal>
    <a-modal v-model="historyVisible" :title="t('history')" width="850px" :footer="null">
      <a-table :data-source="history" :columns="historyColumns" row-key="id" :loading="historyLoading" :pagination="{ pageSize: 10 }" :scroll="{ x: 700 }" />
    </a-modal>
  </div>
</template>

<script>
import request from '@/utils/request'
import { resultsText } from '@/utils/results-service'

export default {
  props: { event: { type: Object, required: true }, entries: { type: Array, default: () => [] }, categories: { type: Array, default: () => [] }, fixedEntryId: Number, showAssignments: {type:Boolean,default:true}, allowNewAssignments: {type:Boolean,default:true} },
  data() { return { representatives: [], claims: [], entryId: undefined, loading: false, busy: false, serial: 0, representativeVisible: false, representativeForm: {}, reviewVisible: false, reviewForm: {}, historyVisible: false, historyLoading: false, history: [] } },
  computed: {
    enabled() { return this.event.claimsEnabled === 1 },
    representativeColumns() { return [
      { title: this.t('teamName'), dataIndex: 'teamName', customRender: (value, row) => this.entryLabel(row) }, { title: this.t('jiangkNo'), dataIndex: 'jiangkNo' },
      { title: this.t('accessState'), dataIndex: 'active', scopedSlots: { customRender: 'active' } },
      { title: this.t('leaderSource'), dataIndex: 'leaderSource', customRender: value => this.t(value || 'EVENT_ASSIGNMENT') },
      { title: this.t('action'), key: 'action', scopedSlots: { customRender: 'action' } }
    ] },
    claimColumns() { return [
      { title: this.t('claimant'), dataIndex: 'displayName' }, { title: 'JiangK ID', dataIndex: 'jiangkNo' }, { title: this.t('teamName'), dataIndex: 'teamName', customRender: (value, row) => this.entryLabel(row) },
      { title: this.t('role'), dataIndex: 'role', scopedSlots: { customRender: 'role' } },
      { title: this.t('claimState'), dataIndex: 'status', scopedSlots: { customRender: 'status' } },
      { title: this.t('submitted'), dataIndex: 'createTime', customRender: value => String(value || '').replace('T', ' ') },
      { title: this.t('action'), key: 'action', scopedSlots: { customRender: 'action' }, width: 200 }
    ] },
    historyColumns() { return [
      { title: this.t('submitted'), dataIndex: 'createTime' }, { title: this.t('action'), dataIndex: 'action' },
      { title: this.t('claimState'), dataIndex: 'toStatus', customRender: value => this.t(value) }, { title: this.t('evidence'), dataIndex: 'reason' }
    ] }
  },
  created() { this.entryId=this.fixedEntryId; this.loadAll() },
  beforeDestroy() { this.serial++ },
  methods: {
    t(key) { return resultsText(this.$adminLocale, key) },
    entryLabel(row) {
      const source = row || {}
      const entry = this.entries.find(item => String(item.id) === String(source.entryId || source.id)) || {}
      const category = this.categories.find(item => String(item.id) === String(source.categoryId || entry.categoryId)) || {}
      // Category database IDs are lookup keys, never a displayed group/race number.
      return [source.categoryName || category.categoryName, source.entryCode || entry.entryCode, source.teamName || entry.teamName].filter(Boolean).join(' · ')
    },
    api(path, params) { return request({ url: `/dragonboat/participation/${path}`, params, silentError: true }) },
    post(path, data) { return request({ url: `/dragonboat/participation/${path}`, method: 'post', data, silentError: true }) },
    report(error) { this.$message.error(error.message || this.t('failed')) },
    async loadAll() {
      this.loading = true
      try {
        if (this.showAssignments) {
          const response = await this.api('representatives', { eventId: this.event.id })
          this.representatives = (response.data || []).filter(row => this.allowNewAssignments || row.leaderSource === 'EVENT_ASSIGNMENT')
        }
        await this.loadClaims()
      } catch (error) { this.report(error) } finally { this.loading = false }
    },
    async loadClaims() {
      const serial = ++this.serial
      this.claims = []
      try {
        const response = await this.api('claims', { eventId: this.event.id, entryId: this.fixedEntryId || this.entryId })
        if (serial === this.serial) this.claims = response.data || []
      } catch (error) { if (serial === this.serial) this.report(error) }
    },
    openRepresentative(row) { this.representativeForm = row ? { ...row, active: 0, verificationNote: '' } : { entryId: undefined, jiangkNo: '', active: 1, verificationNote: '' }; this.representativeVisible = true },
    async saveRepresentative() {
      if (this.busy) return
      const form = this.representativeForm
      if (!form.entryId || !String(form.jiangkNo || '').trim() || !String(form.verificationNote || '').trim()) return this.$message.warning(this.t('required'))
      this.busy = true
      try {
        await this.post('representative', { eventId: this.event.id, entryId: form.entryId, jiangkNo: form.jiangkNo.trim(), verificationNote: form.verificationNote.trim(), active: form.active })
        this.representativeVisible = false
        await this.loadAll()
      } catch (error) { this.report(error) } finally { this.busy = false }
    },
    openReview(row, status) { this.reviewForm = { ...row, status, reason: '' }; this.reviewVisible = true },
    async saveReview() {
      if (this.busy) return
      const form = this.reviewForm
      if (!String(form.reason || '').trim()) return this.$message.warning(this.t('required'))
      this.busy = true
      try {
        await this.post('review', { id: form.id, eventId: this.event.id, version: form.version, status: form.status, reason: form.reason.trim() })
        this.reviewVisible = false
        await this.loadClaims()
      } catch (error) { this.report(error) } finally { this.busy = false }
    },
    async loadHistory() {
      this.historyVisible = true
      this.historyLoading = true
      this.history = []
      try { const response = await this.api('history', { eventId: this.event.id, entryId: this.fixedEntryId || this.entryId }); this.history = response.data || [] } catch (error) { this.report(error) } finally { this.historyLoading = false }
    }
  }
}
</script>

<style scoped>
.section-heading { display: flex; align-items: center; justify-content: space-between; gap: 12px; margin: 25px 0 12px; flex-wrap: wrap; }
h4 { margin: 0; font-size: 17px; }
.muted { color: #687d8b; line-height: 1.7; font-size: 13px; }
.toolbar { display: flex; gap: 8px; flex-wrap: wrap; }
.spaced { margin-top: 12px; }
</style>
